import { render, staticRenderFns } from "./v80a1080HPop.vue?vue&type=template&id=e2cab810&scoped=true"
import script from "./v80a1080HPop.vue?vue&type=script&lang=js"
export * from "./v80a1080HPop.vue?vue&type=script&lang=js"
import style0 from "./v80a1080HPop.vue?vue&type=style&index=0&id=e2cab810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cab810",
  null
  
)

export default component.exports